// extracted by mini-css-extract-plugin
export default {"productCarousel":"C0-z"};